var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.events_list)?_c('div',[_c('p',{staticClass:"text-2xl mb-6"},[_vm._v(" Список сборов ")]),_c('my-loader',{attrs:{"loader":_vm.loader}}),_c('event',{attrs:{"events":_vm.events_list}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }